var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { Slider } from "@riseart/antd-provider";
import { filterSliderCls } from "./Slider.less";
var FilterSlider = /* @__PURE__ */ __name(function FilterSlider2(_ref) {
  var defaultValues = _ref.defaultValues, minRange = _ref.minRange, maxRange = _ref.maxRange, marks = _ref.marks, onAfterChangeHandler = _ref.onAfterChangeHandler, _ref$tipFormatter = _ref.tipFormatter, tipFormatter = _ref$tipFormatter === void 0 ? null : _ref$tipFormatter, _ref$rangeFormatter = _ref.rangeFormatter, rangeFormatter = _ref$rangeFormatter === void 0 ? null : _ref$rangeFormatter;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, rangeFormatter, /* @__PURE__ */ React.createElement(Slider, {
    className: filterSliderCls,
    min: minRange,
    max: maxRange,
    tooltip: {
      formatter: tipFormatter
    },
    range: true,
    step: marks ? null : 1,
    marks,
    defaultValue: defaultValues,
    onAfterChange: onAfterChangeHandler
  }));
}, "FilterSlider");
export {
  FilterSlider
};
